module.exports = __webpack_public_path__ + "img/Logo Pasuk Finder_Blue_Circle.f04ff16d.png";